import { useEffect } from 'react';
import type { EChartsType } from 'echarts/core';

import type { TimeSeries } from '@/shared/charts/time-series-chart/TimeSeriesChart.types';

import type { TooltipCard } from '../tooltip/content/TooltipCard.types';
import { registerNearestSeriesTooltip } from '../tooltip/interaction/registerNearestSeriesTooltip';

type UseNearestSeriesTooltipParams = {
  chart: EChartsType | undefined;
  series: TimeSeries[];
  isEnabled: boolean;
  setTooltipCards: (cards: TooltipCard[]) => void;
};

/** Wires the nearest-series tooltip to the chart's pointer events while the tooltip is on. */
export function useNearestSeriesTooltip({ chart, series, isEnabled, setTooltipCards }: UseNearestSeriesTooltipParams) {
  useEffect(() => {
    if (!chart || chart.isDisposed() || !isEnabled) {
      return;
    }

    return registerNearestSeriesTooltip({ chart, series, setTooltipCards });
  }, [chart, isEnabled, series, setTooltipCards]);
}
